import { createSlice } from '@reduxjs/toolkit';

interface MaterialSelectionState {
	materialSelectionModalVisible: boolean;
}

const initialState: MaterialSelectionState = {
	materialSelectionModalVisible: false,
};

export const materialSelection = createSlice({
	name: 'materialSelection',
	initialState,
	reducers: {
		showMaterialSelectionModal: (state) => {
			state.materialSelectionModalVisible = true;
		},
		closeMaterialSelectionModal: (state) => {
			state.materialSelectionModalVisible = false;
		},
	},
});

// Action creators are generated for each case reducer function
export const { showMaterialSelectionModal, closeMaterialSelectionModal } =
	materialSelection.actions;

export default materialSelection.reducer;
